import { useContext, useReducer, useState } from "react"
import { Fetch } from "../../services/api";
import { notify } from "../../utils/utils";
import { UserContext } from "../../context/provider/UserProvider";

const urlIncidencias = process.env.REACT_APP_PGI_API + "/Concept";

export const useConceptoIncidencia = () => {
    const { stateUser } = useContext(UserContext);
    const conceptoIncidenciaDefault = {
        codIncidenciaConcepto: 0,
        codProductoInterno: 0,
        codNivelCriticidad: 0,
        codNivel: 0,
        nomIncidenciaConcepto: "",
        abrevIncidenciaConcepto: "",
        desIncidenciaConcepto: ""
    }

    const datosEliminarDefault = {
        codIncidenciaConcepto: 0,
        motivo: '',
        nomConcepto: ''
    }

    const conceptoIncidenciaReducer = (estado, accion) => {
        switch(accion.tipo){
            case 'Editar':
                return{
                    ...estado,
                    [accion.key]: accion.value
                };
            case 'Reiniciar': 
                return conceptoIncidenciaDefault;
            default:
                return estado;
    
        }
    }
    const [ conceptosIncidencia, setConceptosIncidencia ] = useState([]);
    const [ conceptoIncidencia, conceptoReducer ] = useReducer(conceptoIncidenciaReducer, conceptoIncidenciaDefault);
    const [ producto, setProducto ] = useState([]);
    const [ datosEliminar, setDatosEliminar ] = useState(datosEliminarDefault)

    const listarProducto = async () => {
        try{
            const response = await Fetch({
                url: urlIncidencias + '/internalProduct',
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setProducto(response.isValid ? response.content : []);
        }
        catch(e){
            notify('Ocurrió un problema en el servicio', 'error');
            setProducto([]);
            console.log('Error al listar producto',e);
        }
    }

    const listarConceptosIncidencia = async (codProductoInterno) => {
        try{
            const response = await Fetch({
                url: urlIncidencias + '?' + new URLSearchParams({
                    CodProductoInterno : codProductoInterno||0
                })
            });
            !response.isValid && notify(response.exceptions[0].description, 'error')
            setConceptosIncidencia(response.isValid ? response.content : [])

        }
        catch(e){
            setConceptosIncidencia([])
            notify('Ocurrió un error en el servicio','error');
            console.log('Error al listar',e)
        }
    }

    const registrarConceptoIncidencia = async () => {
        try{
            const esGuardar = conceptoIncidencia.codIncidenciaConcepto === 0 ? true : false;
            const response = await Fetch({
                url: urlIncidencias,
                method: esGuardar ? 'POST' : 'PUT'  ,
                body: JSON.stringify({
                    ...(!esGuardar && { codIncidenciaConcepto: conceptoIncidencia.codIncidenciaConcepto}),
                    codUsuarioAccion: stateUser.codUsuario ,
                    codProductoInterno: conceptoIncidencia.codProductoInterno,
                    nomIncidenciaConcepto: conceptoIncidencia.nomIncidenciaConcepto,
                    abrevIncidenciaConcepto: conceptoIncidencia.nomIncidenciaConcepto,
                    desIncidenciaConcepto: conceptoIncidencia.desIncidenciaConcepto,
                    codNivelCriticidad: 3, // conceptoIncidencia.codNivelCriticidad,
                    codNivel: conceptoIncidencia.codNivel
                })
            })
            notify(response.isValid ? response.content : response.exceptions[0].description, response.isValid ? 'success' : 'error')
            return response.isValid
        }
        catch(e){
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al registrar ',e)
            return false
        }
    }

    const editarValorConceptoIncidencia = (key, value) => {
        conceptoReducer({
            tipo: 'Editar',
            key: key,
            value: value
        })
    }

    const eliminarConceptoIncidencia = async () => {
        try{
            const response = await Fetch({
                url: urlIncidencias,
                method: 'Delete',
                body: JSON.stringify({
                    codUsuarioAccion: stateUser.codUsuario,
                    codIncidenciaConcepto: datosEliminar.codIncidenciaConcepto,
                    motivo: datosEliminar.motivo
                })
    
            })
            notify(response.isValid ? response.content : response.exceptions[0].description , response.isValid ? 'success' : 'error');
            return response.isValid ;
        }
        catch(error){
            notify('Ocurrió un error en el servicio','error');
            console.error('Error al eliminar: ',error);
            return ;
        }
    }

    const editarValorEliminarConcepto = (key, value) => {
        setDatosEliminar(eliminar => {
            return {
                ...eliminar,
                [key]: value
            }
        });
    }

    return{
        listarConceptosIncidencia,
        conceptosIncidencia,
        conceptoIncidencia,
        editarValorConceptoIncidencia,
        conceptoReducer,
        registrarConceptoIncidencia,
        listarProducto,
        producto,
        eliminarConceptoIncidencia,
        editarValorEliminarConcepto,
        setDatosEliminar,
        datosEliminarDefault,
        datosEliminar
    }
}